export const DisplayMode = {
  MINIMAL: 'minimal',
  FULL: 'full',
};

export const DamageMode = {
  SEVERITY: 'severity',
  PRICING: 'pricing',
  ALL: 'all',
};

export const Severity = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
};

export const CarOrientation = {
  FRONT_LEFT: 0,
  REAR_LEFT: 1,
  REAR_RIGHT: 2,
  FRONT_RIGHT: 3,
};

export const VehicleType = {
  SUV: 'suv',
  CUV: 'cuv',
  SEDAN: 'sedan',
  HATCHBACK: 'hatchback',
  VAN: 'van',
  MINIVAN: 'minivan',
  PICKUP: 'pickup',
};

export const RepairOperation = {
  REPAIR: 'repair',
  REPLACE: 'replace',
};
